var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoUsersImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193,
    height: 195,
    viewBox: "0 0 193 195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#C5C5C5",
    strokeWidth: 2,
    d: "M99.467 147.023c36.533 0 53.467-31.793 53.467-71.011 0-28.726-12.967-51.347-4.967-65.55-11-4.37-35.65-9.206-49.16-9.462C79.296.63 60 4 60 21c-19 0-18.414 36.281-14 47 1.315 3.193 0 4.213 0 8.012 0 39.218 16.934 71.011 53.467 71.011z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M148.6 53.412C143.5 62 125.445 62 111 62c6.778-5.81 6.994-11.104 7-16.088l-.439-.107C113.633 48.97 104.131 50.716 93 54c-6.918 2.041-19.493 5.397-37.723 10.068C49.157 67.692 46.393 69.812 46 69c-4.002-8.272-7-47 13-48C64 2 80.444 1 100 1c16.449 0 35 5 48 10.555-5.574 13.92-2.905 23.586-.071 32.093C149.249 45.364 150 46.954 150 48c0 .57-.036 1.115-.107 1.64L150 50c1.76 5.979 2.093 7.312 1 4l-2.4-.588zm-65.43-2.717A1057.01 1057.01 0 0 0 72.814 55a205.464 205.464 0 0 1 10.358-4.306z",
    opacity: 0.301
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#BABABA",
    opacity: 0.5,
    transform: "translate(76 79.29)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.188,
    cy: 3.742,
    rx: 4.188,
    ry: 3.742
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.813,
    cy: 3.742,
    rx: 4.188,
    ry: 3.742
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#C5C5C5",
    strokeWidth: 2,
    opacity: 0.802,
    transform: "translate(47 69.642)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M45.499 16.639h14.519"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    d: "M26.674 1C18.018 1 11 8.018 11 16.674c0 8.657 7.018 15.675 15.674 15.675h1.886c8.656 0 15.674-7.018 15.674-15.675C44.234 8.018 37.216 1 28.56 1h-1.886z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M.5 9.858l10 7M104.355 10.607l-8.33 4.428"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.234,
    height: 31.349,
    x: 61.766,
    y: 1,
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    rx: 15.674
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M76.333 154.67L59 156.856C71.351 172.771 83.99 180.82 96.917 181c12.926.181 26.287-7.503 40.083-23.052l-18.417-2.185c-7.292 6.343-14.514 9.422-21.666 9.237-7.152-.185-14.014-3.628-20.584-10.33z",
    opacity: 0.652
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C5C5C5",
    strokeWidth: 2,
    d: "M89.242 123.542C106.807 129.998 118.09 118 118.09 118",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C5C5C5",
    strokeWidth: 2,
    d: "M122 143.653H76V156.515c.21.166.552.393 1.015.672.975.586 2.456 1.383 4.437 2.385 3.91 1.978 9.746 4.748 17.507 8.309L122 155.173v-11.52zm-46.141 12.74a.619.619 0 0 0 .011.011z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C5C5C5",
    strokeWidth: 2,
    d: "M12.165 192.908C9.885 170.358 31.164 157.612 76 154.67M184.835 194c2.28-22.55-18.999-35.296-63.835-38.237M148.8 102.24c5.196.73 10.125-3.776 11.009-10.066.883-6.29-2.612-11.98-7.808-12.71M49.921 101.24c-5.195.73-10.124-3.776-11.008-10.066-.884-6.29 2.612-11.98 7.807-12.71M103 95.29v8.19a5 5 0 0 1-5 5h-4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.23
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.772 109.48l-1.685-.285a9.512 9.512 0 0 0-.677-1.635l.993-1.388c.422-.59.355-1.4-.16-1.91l-1.495-1.495a1.471 1.471 0 0 0-1.905-.16l-1.394.993a9.413 9.413 0 0 0-1.694-.697l-.28-1.665A1.481 1.481 0 0 0 13.01 100H10.9a1.481 1.481 0 0 0-1.464 1.238l-.291 1.705a9.275 9.275 0 0 0-1.63.687l-1.378-.993a1.481 1.481 0 0 0-1.91.16l-1.5 1.495a1.484 1.484 0 0 0-.16 1.91l1.003 1.409a9.29 9.29 0 0 0-.667 1.64l-1.665.28A1.481 1.481 0 0 0 0 110.995v2.11a1.481 1.481 0 0 0 1.238 1.464l1.705.291c.176.564.406 1.11.687 1.63l-.988 1.373c-.423.59-.355 1.4.16 1.91l1.495 1.495a1.471 1.471 0 0 0 1.905.16l1.409-1.003a9.485 9.485 0 0 0 1.584.652l.28 1.685c.12.715.74 1.24 1.465 1.238h2.115a1.481 1.481 0 0 0 1.464-1.238l.286-1.685a9.512 9.512 0 0 0 1.634-.677l1.39.993c.25.18.552.277.862.276.393 0 .77-.157 1.047-.436l1.494-1.495c.513-.512.58-1.32.16-1.91l-.992-1.393c.276-.523.503-1.07.677-1.635l1.685-.28A1.481 1.481 0 0 0 24 113.054v-2.11a1.463 1.463 0 0 0-1.228-1.464zm-.116 3.575a.13.13 0 0 1-.11.13l-2.106.352a.673.673 0 0 0-.541.496 8.026 8.026 0 0 1-.873 2.1.678.678 0 0 0 .03.738l1.239 1.744a.136.136 0 0 1-.015.17l-1.494 1.495a.127.127 0 0 1-.095.04.123.123 0 0 1-.076-.025l-1.74-1.238a.677.677 0 0 0-.736-.03 8.026 8.026 0 0 1-2.101.872.665.665 0 0 0-.496.541l-.356 2.106a.13.13 0 0 1-.13.11h-2.111a.13.13 0 0 1-.13-.11l-.352-2.106a.673.673 0 0 0-.496-.541 8.334 8.334 0 0 1-2.056-.842.694.694 0 0 0-.34-.09.66.66 0 0 0-.392.125l-1.754 1.248a.15.15 0 0 1-.076.025.134.134 0 0 1-.095-.04l-1.494-1.494a.136.136 0 0 1-.015-.17l1.233-1.73a.686.686 0 0 0 .03-.742 7.95 7.95 0 0 1-.882-2.096.686.686 0 0 0-.541-.496l-2.121-.361a.13.13 0 0 1-.11-.13v-2.111a.13.13 0 0 1 .11-.13l2.09-.352a.678.678 0 0 0 .547-.5c.184-.74.473-1.449.857-2.107a.67.67 0 0 0-.035-.732l-1.248-1.754a.136.136 0 0 1 .015-.17l1.494-1.495a.127.127 0 0 1 .095-.04c.027 0 .054.009.075.025l1.73 1.233c.22.155.51.167.742.03a7.95 7.95 0 0 1 2.096-.882c.256-.07.45-.28.496-.541l.361-2.121a.13.13 0 0 1 .13-.11h2.111a.13.13 0 0 1 .13.11l.351 2.09c.044.266.241.48.502.547.755.19 1.48.487 2.15.882.23.137.52.125.738-.03l1.73-1.243a.15.15 0 0 1 .075-.025c.035 0 .07.015.095.04l1.494 1.494c.044.046.05.117.015.17l-1.238 1.74a.677.677 0 0 0-.03.737c.388.656.682 1.363.872 2.101.064.26.278.455.541.496l2.106.356a.13.13 0 0 1 .11.13l-.005 2.111z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 107a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 8.693a3.693 3.693 0 1 1 0-7.386 3.693 3.693 0 0 1 0 7.386z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 49,
    r: 6,
    stroke: "#C5C5C5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#C5C5C5",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180 126.36v17.34M171 135h18"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUsersImage);
export default __webpack_public_path__ + "static/media/noUsersImage.86b3f4f1ded5fb6e7ce12161db97af56.svg";
export { ForwardRef as ReactComponent };